import React from 'react'

import UnauthorizedPage from '../index'
import PolicyLinks from './PolicyLinks'
import AcceptInviteForm from './AcceptInviteForms/AcceptInviteForm'
import AcceptBetaInviteForm from './AcceptInviteForms/AcceptBetaInviteForm'

import { createJsonFromQueryString } from '../../../helpers/url'

import history from '../../../history'
import { BETA_INVITE } from '../../../constants/other'

import useAuthStyles from '../../../styles/common/authPages'

// this page is basically combination of SignUp and CreatePassword
// it allows for user who received invite and doesn't have an account to create it within the password right away
function AcceptInvite() {
  const authClasses = useAuthStyles()

  // t param is used to determine which type of invite we have, e.g. i - user event, bi - beta invite
  const { token, t: inviteTypeQueryParam } = createJsonFromQueryString(history.location.search, false)

  const renderAcceptInviteForm = () => {
    // todo add userCountry determination
    if (inviteTypeQueryParam === BETA_INVITE) {
      return <AcceptBetaInviteForm token={token} userCountry={''} />
    } else {
      return <AcceptInviteForm token={token} userCountry={''} />
    }
  }

  return (
    <UnauthorizedPage helmetTitle="Accept Invite" className={authClasses.authPage}>
      <div className={authClasses.formContainer}>
        {renderAcceptInviteForm()}
        <PolicyLinks />
      </div>
    </UnauthorizedPage>
  )
}

export default AcceptInvite
